export default "__VITE_ASSET__RIG60WvC__"